import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useNavigate } from 'react-router-dom';
import { responsiveFont, responsivePaddingHorizontal, responsivePaddingVertical, responsiveImageSize } from '../../components/common/responsive.utils';
import Logo from '../../assets/icon/common/main_web_logo.svg';
import TitleLogoMobile from '../../assets/icon/sitter/mobile/title_logo.svg';
import MenuIconMobile from '../../assets/icon/partner/menu.svg';

interface MainSitterwebHeader_WebProps {
    openDialog: () => void;
}

const MainSitterwebHeader_Web: React.FC<MainSitterwebHeader_WebProps> = ({ openDialog }) => {
    // 데스크탑-웹: 768px ~ 1920px
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles(); 
    const navigate = useNavigate();

    const pressMain = () => {
        navigate("/")
    }

    const onMenu = () => {
        navigate("/sitter/menu");
    }

    return (
        <>
            {isWeb ? (
                <>
                    <div className="webHeader_Web" style={styles.webHeader_Web}>
                        <img
                            src={Logo}
                            alt=""
                            className="webImage10_Web"
                            style={styles.webImage10_Web}
                        />

                        <div className="headerButton_Web" style={styles.headerButton_Web} onClick={openDialog}>
                            <span className="headerButton_WebText_Web" style={styles.headerButton_WebText_Web}>이웃시터 지원하기</span>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div style={styles.header_Mobile}>
                        <img src={TitleLogoMobile} style={styles.titleLogo_Mobile} alt="로고" onClick={() => pressMain()} />
                        <img src={MenuIconMobile} alt="메뉴" style={styles.menu_Mobile} onClick={() => onMenu()} />
                    </div>
                </>
            )}
        </>
    );
}

const getStyles = (): Record<string, React.CSSProperties> => ({
    webHeader_Web: { height: "132px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%", zIndex: 1000, boxSizing: "border-box", top: 0, left: 0, position: "fixed", backgroundColor: "white", paddingTop: responsivePaddingVertical(4, 30), paddingBottom: responsivePaddingVertical(4, 34), cursor: "pointer", paddingLeft: responsivePaddingHorizontal(24, 180), paddingRight: responsivePaddingHorizontal(24, 180) },
    webImage10_Web: { width: responsiveImageSize(96, 405), height: responsiveImageSize(30, 40) },
    headerButton_Web: { width: "260px", height: "68px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "80px", backgroundColor: "#9F6BFF" },
    headerButton_WebText_Web: { fontFamily: "Pretendard", fontSize: responsiveFont(16, 26), fontWeight: 700, lineHeight: "2.1549vw", letterSpacing: "-0.03em", textAlign: "left", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "#fff" },
    
    header_Mobile: { height: responsiveImageSize(60, 132), backgroundColor: "white", display: "flex", top: 0, left: 0, position: "fixed", paddingTop: responsivePaddingVertical(4, 30), paddingBottom: responsivePaddingVertical(4, 34), cursor: "pointer", paddingLeft: responsivePaddingHorizontal(24, 180), paddingRight: responsivePaddingHorizontal(24, 180), width: "100%", zIndex: 1000, boxSizing: "border-box", flexDirection: "row", justifyContent: "space-between", alignItems: "center" },
    titleCon_Mobile: { display: "flex", boxSizing: "border-box", paddingBottom: 0 },
    titleLogo_Mobile: { width: responsiveImageSize(96, 405), height: responsiveImageSize(30, 40), cursor: "pointer" },
    headerLogo_Mobile: { cursor: "pointer", WebkitUserSelect: "none", MozUserSelect: "none", msUserSelect: "none", userSelect: "none" },
    menu_Mobile: { width: responsiveImageSize(30, 40), height: responsiveImageSize(30, 40), cursor: "pointer" }
});

export default MainSitterwebHeader_Web;